import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import {
  PersonAddAlt as AddCustomerIcon,
  Edit as IconEdit,
  DeleteOutlineOutlined as DeleteIcon,
  SummarizeOutlined as ViewSummaryIcon,
  ListAltOutlined as OrderFromIcon,
  DoDisturbAltOutlined as RemoveNegativeIcon,
  ReceiptLongOutlined as GenerateBillIcon,
  EventRepeatOutlined as ReturnIcon,
  PreviewOutlined as PreviewIcon,
} from "@mui/icons-material";

import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";
import TxtRow from "components/Custom/TxtRow";
import AutoComplete from "components/Custom/AutoComplete";
import UiAccordion from "components/Custom/UiAccordion";
import UiDialog from "components/Custom/UiDialog";
import AddSalesInvoice from "components/Sales/AddSalesInvoice";
import RadioBtn from "components/Custom/RadioBtn";

import { ERRORS, LABELS, SUCCESS, TITLES } from "common/lables";
import { DateFunctions } from "common//datefunctions";
import { COMMON_JS } from "common/scripts";
import { NOTIFY } from "common/config";
import { COLORS } from "common/colors";
import { PRODUCT_APIs } from "apihandlers/product";
import { USER_APIs } from "apihandlers/user";
import { TRANS_APIs } from "apihandlers/transaction";
import { GEO_APIs } from "apihandlers/geography";
import { CUSTOMER_APIs } from "apihandlers/customer";
import { ORDER_APIs } from "apihandlers/order";
import { MASTER_APIs } from "apihandlers/master";

import ItemSummary from "./ItemSummary";
import SalesInvoiceBillPrint from "./print/SalesInvoiceBillPrint";
import OrderSummaryPrint from "./print/OrderSummaryPrint";
import OrderSkeleton from "./OrderSkeleton";
import OrderForm from "./print/OrderForm";
import ItemReturn from "./ItemReturn";
import CustomerForm from "components/Masters/Customer/customerForm";

const SalesInvoice = (props: any) => {
  const { setDashMenu } = props;

  const productRef: any = useRef(null);
  const userRef: any = useRef(null);
  const areasRef: any = useRef(null);
  const partyRef: any = useRef(null);
  const salesInvoiceRef: any = useRef(null);
  const salesInvoiceChildRef: any = useRef(null);
  const vehicleRef: any = useRef(null);
  const branchRef: any = useRef(null);
  const stockRef: any = useRef(null);
  const schemeRef: any = useRef(null);

  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState<any>(null);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [deletedRow, setDeletedRow] = useState<any>({});
  const [products, setProducts] = useState<any>([]);
  const [areas, setAreas] = useState<any>([]);
  const [vehicles, setVehicles] = useState<any>([]);
  const [parties, setParties] = useState<any>([]);
  const [users, setUsers] = useState<any>([]);
  const [branches, setBranches] = useState<any>([]);
  const [stockLoad, setStockLoad] = useState<any>([]);
  const [orderItems, setOrderItems] = useState<any>([]);
  const [schemes, setSchemes] = useState<any>([]);
  const [resetArgs, setResetArgs] = useState<any>({});
  const [expand, setExpand] = useState(true);
  const [salesInvoice, SetsalesInvoice] = useState<boolean>(false);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [resetUsers, setResetUsers] = useState<any>({
    id: -1,
    label: "Select User",
  });
  const [resetRoute, setResetRoute] = useState<any>({
    id: -1,
    label: "Select Route",
  });
  const [resetParty, setResetParty] = useState<any>({
    id: -1,
    label: "Select Party",
  });
  const [resetProduct, setResetProduct] = useState<any>({
    id: -1,
    label: "Select Product",
  });
  const [resetFormDate, setResetFormDate] = useState<any>(
    DateFunctions.getDate("2days", "from", "YYYY-MM-DD")
  );
  const [resetToDate, setResetToDate] = useState<any>(
    DateFunctions.getDate("today", "to", "YYYY-MM-DD")
  );
  const [partyId, setPartyId] = useState();

  const [manageSummaryDialog, setManageSummaryDialog] =
    useState<boolean>(false);
  const [managePrintBillDialog, setManagePrintBillDialog] =
    useState<boolean>(false);
  const [manageOrderForm, setManageOrderForm] = useState<boolean>(false);
  const [manageEInvoice, setManageEInvoice] = useState<boolean>(false);
  const [managePrintDialog, setManagePrintDialog] = useState<boolean>(false);
  const [manageReturnDialog, setManageReturnDialog] = useState<boolean>(false);
  const [customerFormDialog, setCustomerFormDialog] = useState<boolean>(false);
  const [managePreviewDialog, setManagePreviewDialog] =
    useState<boolean>(false);

  const invoiceCols = [
    {
      key: "",
      selectColumn: true,
    },
    {
      key: "expanded",
    },
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "orderDate",
      type: "datetime",
      editable: true,
      sortable: true,
      searchable: true,
      name: LABELS.DATE,
      width: "10%",
    },
    {
      key: "invoiceNumber",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.BILL_NO,
      width: "10%",
    },
    {
      key: "shopName", //tobe changed as customerName
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.SHOP_NAME,
      width: "10%",
    },
    {
      key: "routeName",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ROUTE_NAME,
      width: "10%",
    },
    {
      key: "address",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ADDRESS,
      width: "10%",
    },
    {
      key: "totalQty",
      name: LABELS.ITEMS,
      editable: true,
      sortable: true,
      searchable: true,
      type: "number",
      width: "5%",
    },
    {
      key: "total",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.AMOUNT,
      width: "10%",
      renderSum: true,
    },
    {
      key: "customerName", //tobe changed as salesMan
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.SALESMAN,
      width: "10%",
    },
    {
      key: "preview",
      name: LABELS.BILL,
      width: "8%",
      renderCell: (params: any) => (
        <div className="options">
          <Tooltip title={LABELS.PREVIEW} placement="bottom">
            <IconButton className="iconBtn" onClick={() => preview(params.row)}>
              <PreviewIcon />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
    {
      key: "returnOption",
      name: LABELS.RETURN,
      width: "8%",
      renderCell: (params: any) => (
        <div className="options">
          <Tooltip title={LABELS.RETURN} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onReturn(params.row)}
            >
              <ReturnIcon />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const formulaRenderer = (row) => {
    console.log("formulaRenderer: ", row, products);
    const productPrice = products.find((productPrice) => {
      return productPrice.id === row.productNameId;
    });

    row["price"] = productPrice.price;
    let soldSkuDup = Number(row["soldSkuDup"] || 0);
    let price = Number(row["price"] || 0);
    let orderItemTotal = 0;
    if (!isNaN(soldSkuDup) && !isNaN(price)) {
      orderItemTotal = price * soldSkuDup;
    }
    row["orderItemTotal"] = orderItemTotal;
    return row;
  };

  const orderItemColumns = [
    // {
    //   key: "",
    //   selectColumn: true,
    // },
    {
      key: "slNo",
      type: "text",
      editable: false,
      sortable: false,
      searchable: false,
      name: LABELS.SL_NO,
      width: "5%",
    },
    {
      key: "productName",
      type: "dropdown",
      list: products,
      editable: true,
      sortable: false,
      searchable: false,
      name: LABELS.PRODUCT_NAME,
      width: "35%",
      formula: formulaRenderer,
      // isDisabled: (row: any) => {
      //   return row.productId == 38;
      // },
    },
    {
      key: "price",
      type: "number",
      editable: false,
      sortable: false,
      searchable: false,
      name: LABELS.PRICE,
      width: "10%",
      formula: formulaRenderer,
      renderSum: true,
    },
    {
      key: "soldSkuDup",
      type: "number",
      editable: true,
      sortable: false,
      searchable: false,
      name: LABELS.QTY,
      width: "20%",
      renderSum: true,
      formula: formulaRenderer,
      // isDisabled: (row: any) => {
      //   return row.sold <= 0;
      // },
    },
    {
      key: "orderItemTotal",
      type: "number",
      editable: false,
      sortable: false,
      searchable: false,
      name: LABELS.AMOUNT,
      width: "20%",
      formula: formulaRenderer,
      renderSum: true,
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      width: "10%",
      renderCell: (params: any) => (
        <div className="options">
          <Tooltip title={LABELS.DELETE} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onDelete(params.row)}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (loading) {
      getRoutes();
    }
  }, [loading]);

  const getRoutes = () => {
    const args = {
      activeStatus: true,
    };
    GEO_APIs.getAreas(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.areaName,
          };
        });
        setAreas(list);
        getParty();
      }
    });
  };

  const getParty = (areaId = null) => {
    const args = {
      areaId,
      activeStatus: true,
    };
    CUSTOMER_APIs.getCustomerProfiles(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.name,
          };
        });
        setParties(list);
        if (areaId == null) {
          getRows();
        }
        getProducts();
      }
    });
  };

  const getProducts = () => {
    const args = {
      activeStatus: true,
    };
    PRODUCT_APIs.getProductsSku(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.productName,
            price: r.price,
          };
        });
        setProducts(list);
        getUsers();
      }
    });
  };

  const getUsers = () => {
    const args = {
      activeStatus: true,
    };
    USER_APIs.getUsers(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.fullName,
          };
        });
        setUsers(list);
        getBranches();
      }
    });
  };

  const getBranches = () => {
    const args = {
      activeStatus: true,
    };
    MASTER_APIs.getBranchProfile(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.name,
          };
        });
        setBranches(list);
        getSchemes();
      }
    });
  };

  const getSchemes = () => {
    const args = {
      activeStatus: true,
    };
    MASTER_APIs.getSchemes(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.name,
          };
        });
        setSchemes(list);

        getStockLoad();
      }
    });
  };

  const getStockLoad = () => {
    const args = {
      activeStatus: true,
    };
    TRANS_APIs.getStockLoad(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        // let list = response.stockLoad.map((r) => {
        //   return {
        //     id: r.id,
        //     label: r.name,
        //   };
        // });
        setStockLoad([]);
        getRows();
      }
    });
  };

  // const getOrderItems = () => {
  //   const args = {
  //     activeStatus: true,
  //   };
  //   TRANS_APIs.getOrders(args).then((res: any) => {
  //     const response: any = res.response;
  //     const { status } = res;
  //     if (status === 200) {
  //       let list = response.records.map((r) => {
  //         return {
  //           id: r.id,
  //           label: r.fullName,
  //         };
  //       });
  //       setStockLoad(list);
  //       getRows();
  //     }
  //   });
  // };

  const getRows = async () => {
    try {
      const fromDate = (
        document.getElementById("fromDate") as HTMLInputElement
      ).value.trim();
      const toDate = (
        document.getElementById("toDate") as HTMLInputElement
      ).value.trim();
      // const routeId = areasRef.current.selectedValue.id;
      // const partyId = partyRef.current.selectedValue.id;
      // setPartyId(partyId);
      // const productId = productRef.current.selectedValue.id;
      // const userId = userRef.current.selectedValue.id;
      const args = {
        isSale: "true",
        isReturn: "false",
        fromDate,
        toDate,
        routeId: resetRoute.id,
        partyId: resetParty.id,
        productId: resetProduct.id,
        userId: resetUsers.id,
        // customerType todo
      };
      setRows(null);
      // tr/v1/RPG0MVQIH4QB6QNF	getDmsInvoices
      const res: any = await ORDER_APIs.getOrders(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < list.length; i++) {
          list[i]["slNo"] = i + 1;
          list[i]["_type"] = "maingrid";
          list[i]["_expanded"] = false;
          let subList = list[i].items;
          let orderId = list[i].id;
          for (let j = 0; j < subList.length; j++) {
            subList[j]["slNo"] = j + 1;
          }
          list[i]["_subGrid"] = () => subGrid(subList, orderId);
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getOrders:", error);
    }
  };

  const mangeSalesInvoice = () => {
    // Validations;
    //let errors = [];
    // if (countryName == "") {
    //   errors.push({
    //     id: "symbol",
    //     msg:
    //       "<span class='bold'>" +
    //       LABELS.COUNTRY_NAME +
    //       "</span> " +
    //       WARNINGS.IS_A_REQUIRED_FIELD,
    //   });
    // }
    // if (countryCode == "") {
    //   errors.push({
    //     id: "symbol",
    //     msg:
    //       "<span class='bold'>" +
    //       LABELS.COUNTRY_CODE +
    //       "</span> " +
    //       WARNINGS.IS_A_REQUIRED_FIELD,
    //   });
    // }
    // if (countryDialCode == "") {
    //   errors.push({
    //     id: "code",
    //     msg:
    //       "<span class='bold'>" +
    //       LABELS.COUNTRY_DIAL_CODE +
    //       "</span> " +
    //       WARNINGS.IS_A_REQUIRED_FIELD,
    //   });
    // }
    // setMandatoryResults(errors);
    // if (errors.length > 0) {
    //   COMMON_JS.showNotify(
    //     props,
    //     NOTIFY.WARNING,
    //     WARNINGS.PLEASE_CHECK_FORM_ERRORS
    //   );
    //   return;
    // }
    let gridRows = salesInvoiceChildRef.getRowData();
    let gridRowsJson = {};
    for (let i = 0; i < gridRows.length; i++) {
      const row = gridRows[i];
      const orderId = row.orderId;
      if (!gridRowsJson[orderId]) {
        gridRowsJson[orderId] = [];
      }
      gridRowsJson[orderId].push({
        orderId: row.orderId,
        orderItemId: -1,
        productSkuId: row.productSkuId,
        soldSku: row.soldSku,
        invoiceSku: row.soldSkuDup,
      });
    }
    const args = {
      customerId: 70,
      areaId: 6104,
      isInvoice: "true",
      rows: gridRowsJson,
    };
    ORDER_APIs.manageOrders(args).then((res) => {
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  // todo comment which is not needed
  const onDelete = (row: any) => {
    salesInvoiceChildRef.deleteRow(row.id);
    const args = {
      orderItemId: row.id,
    };
    TRANS_APIs.deleteOrderItem(args).then((res) => {
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_DELETE);
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const preview = (row) => {
    setSelectedRow(row);
    setManagePreviewDialog(true);
  };

  const onReturn = (row: any) => {
    setSelectedRow(row);
    // tr/v1/0ENO629836U0X7RM	manageDmsInvoice
    setManageReturnDialog(true);
  };
  console.log("selectedRow", selectedRow);

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const viewSummary = (e) => {
    const summaryRows = salesInvoiceRef.getSelectedRows();
    if (summaryRows.length == 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        "Please select atleast one Order!..."
      );
    } else {
      setManageSummaryDialog(true);
    }
  };

  const ordedrForm = (e) => {
    const orderRow = salesInvoiceRef.getSelectedRows();
    console.log("orderRow", orderRow);
    if (orderRow.length == 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        "Please select atleast one Order!..."
      );
    } else {
      setManageOrderForm(true);
    }
  };

  // const eInvoice = (e) => {
  //   setManageEInvoice(true);
  // };

  const printSummary = () => {
    const orderRow = salesInvoiceRef.getSelectedRows();
    if (orderRow.length === 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        "Please select atleast one Order!..."
      );
    } else {
      setManagePrintDialog(true);
      const html = document.getElementById("orderSummary").innerHTML;
      COMMON_JS.printHtml(html);
    }
  };

  // const generateBill = (e) => {
  //   const orderRow = salesInvoiceRef.getSelectedRows();
  //   if (orderRow.length === 0) {
  //     COMMON_JS.showNotify(
  //       props,
  //       NOTIFY.WARNING,
  //       "Please select atleast one Order!..."
  //     );
  //   } else {
  //     setManagePrintDialog(true);
  //   }
  // };
  const printBill = () => {
    const orderRow = salesInvoiceRef.getSelectedRows();
    if (orderRow.length === 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        "Please select atleast one Order!..."
      );
    } else {
      setManagePrintBillDialog(true);
      const html = document.getElementById("salesInvoiceBill").innerHTML;
      COMMON_JS.printHtml(html);
    }
  };

  const handleAreaChange = async (e, f) => {
    setResetRoute(f);
    if (f.id) {
      getParty(f.id);
    }
  };

  const userChange = (e, val) => {
    setResetUsers(val);
  };
  const partyChange = (e, val) => {
    setResetParty(val);
  };
  const productChange = (e, val) => {
    setResetProduct(val);
  };
  const onFromDateChange = (e) => {
    setResetFormDate(e.target.value);
  };
  const onToDateChange = (e) => {
    setResetToDate(e.target.value);
  };

  const onReset = () => {
    setResetFormDate(DateFunctions.getDate("today", "from", "YYYY-MM-DD"));
    setResetToDate(DateFunctions.getDate("thismonth", "to", "YYYY-MM-DD"));
    setResetUsers({ id: -1, label: "Select User" });
    setResetRoute({ id: -1, label: "Select Route" });
    setResetParty({ id: -1, label: "Select Party" });
    setResetProduct({ id: -1, label: "Select Product" });
  };

  const subGrid = (subRows = [], orderId) => {
    console.log("subList:", subRows, orderId);
    return (
      <>
        <ExcelGrid
          id={"salesInvoiceSubGrid"}
          childRef={salesInvoiceChildRef}
          cols={orderItemColumns}
          rows={subRows}
          isSubGrid={subRows.length !== 0 ? true : true}
          noTotalRows={true}
          getDefaultNewRow={() => getDefaultNewRow(orderId)}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "right",
            width: "99%",
          }}
        >
          <div
            style={{
              width: "35%",
              display: "flex",
              justifyContent: "right",
            }}
          >
            <Btn
              text={LABELS.SAVE}
              onClick={mangeSalesInvoice}
              marginRight={15}
              bgColor={COLORS.GRID_ADD_NEW}
              //  loading={isSubmit}
            />
          </div>
        </div>
      </>
    );
  };

  const getDefaultNewRow = (orderId) => {
    const newRow: any = {
      id: orderId + salesInvoiceChildRef.getRowData().length + 1,
      orderId: orderId,
      orderItemId: -1,
      productId: "",
      price: "",
      sold: "",
    };
    return newRow;
  };

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => props.setDashMenu(LABELS.HOME)}>{LABELS.SALES}</li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.SALES_INVOICE}</li>
        </ul>
        <h4>{TITLES.SALES_INVOICE}</h4>
      </div>
      <div className=" filterBorder" style={{ width: "96%" }}>
        <UiAccordion
          id={"filter"}
          title={LABELS.FILTER}
          expanded={expand}
          onChange={() => {
            setExpand(!expand);
          }}
        >
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                label={LABELS.FROM_DATE}
                type={"date"}
                id="fromDate"
                value={resetFormDate}
                onChange={onFromDateChange}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                label={LABELS.TO_DATE}
                type={"date"}
                id="toDate"
                value={resetToDate}
                onChange={onToDateChange}
              />
            </div>
            <div className="formGroup width30">
              <label>{LABELS.ROUTE}</label>
              <AutoComplete
                list={areas}
                childRef={areasRef}
                inputValue={resetRoute.id ? resetRoute : ""}
                onChange={handleAreaChange}
              />
            </div>
          </div>

          <div className="flexRowAround" style={{ margin: 0, padding: 0 }}>
            <div className="formGroup width25">
              <label>{LABELS.PARTY}</label>
              <AutoComplete
                list={parties}
                childRef={partyRef}
                inputValue={resetParty.id ? resetParty : ""}
                onChange={partyChange}
              />
            </div>
            <div className=" width5" style={{ marginTop: 18 }}>
              <Tooltip title={LABELS.ADD_NEW_PARTY} placement="bottom">
                <IconButton
                  className="iconBtn"
                  onClick={() => {
                    setCustomerFormDialog(true);
                  }}
                >
                  <AddCustomerIcon sx={{ color: "blue" }} />
                </IconButton>
              </Tooltip>
            </div>
            <div className="formGroup width30">
              <label>{LABELS.PRODUCT}</label>
              <AutoComplete
                list={products}
                childRef={productRef}
                inputValue={resetProduct.id ? resetProduct : ""}
                onChange={productChange}
              />
            </div>
            <div className="formGroup width30">
              <label>{LABELS.USER}</label>
              <AutoComplete
                list={users}
                childRef={userRef}
                inputValue={resetUsers.id ? resetUsers : ""}
                onChange={userChange}
              />
            </div>
          </div>
          <div className="flexRowAround" style={{ margin: 0, padding: 0 }}>
            <div className="formGroup width60">
              <label>{LABELS.WANT_TO_PRINT_SALES_BILL_WITH}</label>
              <RadioBtn
                list={[
                  {
                    id: "invoice",
                    value: "Invoice",
                    label: LABELS.INVOICE,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === "Invoice"
                      : true,
                    disabled: false,
                  },
                  {
                    id: "estimation",
                    value: "Estimation",
                    label: LABELS.ESTIMATION,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === "Estimation"
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"activeStatus"}
                //disabled={isSubmit}
              />
            </div>
            <div
              className="formGroup width30"
              style={{ margin: 0, padding: 0 }}
            >
              <div className="flexbtnLoad" style={{ margin: 0, padding: 0 }}>
                <Btn
                  text={LABELS.RESET}
                  bgColor={COLORS.RELOAD_EXPORT}
                  color={COLORS.RELOAD_EXPORT_TEXT}
                  onClick={onReset}
                  //loading={isSubmit}
                />
                <Btn
                  text={LABELS.LOAD}
                  onClick={getRows}
                  bgColor={COLORS.GRID_ADD_NEW}
                  // loading={isSubmit}
                />
              </div>
            </div>
          </div>
        </UiAccordion>
      </div>
      <div>
        {rows ? (
          <>
            <div className="grid excelGridWrapper">
              <ExcelGrid
                id={"salesInvoice"}
                childRef={salesInvoiceRef}
                height={window.innerHeight * 0.5}
                cols={invoiceCols}
                rows={rows}
                exportOption={true}
                newRowOption={false}
                hideUnhide={true}
                totalRowsColIndex={3}
                // freezeOption={true}
                exportName={LABELS.SALES_ORDER}
                onReload={reloadGrid}
                leftSideWidth={"80%"}
                rightSideWidth={"20%"}
                leftSideBtns={
                  <>
                    {/* <div className="excelBtnWrapper">
                      <Btn
                        startIcon={<ViewSummaryIcon sx={{ color: "blue" }} />}
                        text={LABELS.E_INVOICE}
                        onClick={eInvoice}
                        bgColor={COLORS.GRID_HEADER}
                        color={COLORS.RELOAD_EXPORT_TEXT}
                      />
                    </div> */}
                    <div className="excelBtnWrapper">
                      <Btn
                        startIcon={<ViewSummaryIcon sx={{ color: "blue" }} />}
                        text={LABELS.VIEW_SUMMARY}
                        onClick={viewSummary}
                        bgColor={COLORS.GRID_HEADER}
                        color={COLORS.RELOAD_EXPORT_TEXT}
                      />
                    </div>
                    <div className="excelBtnWrapper">
                      <Btn
                        startIcon={<OrderFromIcon sx={{ color: "blue" }} />}
                        text={LABELS.ORDER_FROM}
                        onClick={ordedrForm}
                        bgColor={COLORS.GRID_HEADER}
                        color={COLORS.RELOAD_EXPORT_TEXT}
                      />
                    </div>
                    <div className="excelBtnWrapper">
                      <Btn
                        startIcon={<GenerateBillIcon sx={{ color: "blue" }} />}
                        text={LABELS.PRINT_SUMMARY}
                        onClick={printSummary}
                        bgColor={COLORS.GRID_HEADER}
                        color={COLORS.RELOAD_EXPORT_TEXT}
                      />
                    </div>
                    <div className="excelBtnWrapper">
                      <Btn
                        startIcon={<GenerateBillIcon sx={{ color: "blue" }} />}
                        text={LABELS.PRINT_BILL}
                        onClick={printBill}
                        bgColor={COLORS.GRID_HEADER}
                        color={COLORS.RELOAD_EXPORT_TEXT}
                      />
                    </div>
                  </>
                }
              />
            </div>
          </>
        ) : (
          <OrderSkeleton />
        )}

        {customerFormDialog && (
          <UiDialog
            title={"Add New " + LABELS.PARTY}
            open={true}
            size={"xl"}
            onClose={() => {
              setCustomerFormDialog(false);
            }}
          >
            <CustomerForm
              selectedRow={selectedRow}
              setSelectedRow={setSelectedRow}
              setManageDialog={setCustomerFormDialog}
              reloadGrid={reloadGrid}
            />
          </UiDialog>
        )}

        {manageSummaryDialog && (
          <UiDialog
            title={LABELS.ITEM_SUMMARY + ": "}
            open={true}
            size={"md"}
            onClose={() => {
              setManageSummaryDialog(false);
            }}
          >
            <ItemSummary salesInvoiceRef={salesInvoiceRef} />
          </UiDialog>
        )}

        {manageOrderForm && (
          <UiDialog
            title={LABELS.ORDER_FROM + ": "}
            open={true}
            size={"md"}
            onClose={() => {
              setManageOrderForm(false);
            }}
          >
            <OrderForm salesInvoiceRef={salesInvoiceRef} />
          </UiDialog>
        )}

        {/* {manageEInvoice && (   //todo: tobe  commented as per the demo.
          <UiDialog
            title={LABELS.E_INVOICE + ": "}
            open={true}
            size={"md"}
            onClose={() => {
              setManageEInvoice(false);
            }}
          >
            {"E Invoice "}
          </UiDialog>
        )} */}

        {managePrintDialog && (
          <UiDialog
            title={LABELS.ORDER_SUMMARY + ": "}
            open={true}
            size={"md"}
            onClose={() => {
              setManagePrintDialog(false);
            }}
          >
            <div style={{ height: "100%" }}>
              <div
                style={{
                  height: "70%",
                  overflow: "auto",
                  marginBottom: "1.5rem",
                }}
              >
                <OrderSummaryPrint salesInvoiceRef={salesInvoiceRef} />
              </div>
              <div
                style={{
                  margin: "0.5rem",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "right",
                  width: "95%",
                  zIndex: 999,
                  position: "fixed",
                  bottom: 0,
                }}
              >
                <div
                  style={{
                    width: "35%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <Btn
                    text={LABELS.PRINT_SUMMARY}
                    onClick={printSummary}
                    marginRight={15}
                    bgColor={COLORS.GRID_ADD_NEW}
                    //  loading={isSubmit}
                  />
                </div>
              </div>
            </div>
          </UiDialog>
        )}

        {managePrintBillDialog && (
          <UiDialog
            title={LABELS.BILL_STATUS + ": "}
            open={true}
            size={"md"}
            onClose={() => {
              setManagePrintBillDialog(false);
            }}
          >
            <div style={{ height: "100%" }}>
              <div
                style={{
                  height: "70%",
                  overflow: "auto",
                  marginBottom: "1.5rem",
                }}
              >
                <SalesInvoiceBillPrint salesInvoiceRef={salesInvoiceRef} />
              </div>
              <div
                style={{
                  margin: "0.5rem",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "right",
                  width: "95%",
                  zIndex: 999,
                  position: "fixed",
                  bottom: 0,
                }}
              >
                <div
                  style={{
                    width: "35%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <Btn
                    text={LABELS.PRINT_SUMMARY}
                    onClick={printBill}
                    marginRight={15}
                    bgColor={COLORS.GRID_ADD_NEW}
                    //  loading={isSubmit}
                  />
                </div>
              </div>
            </div>
          </UiDialog>
        )}

        {manageReturnDialog && (
          <UiDialog
            title={LABELS.RETURN_SUMMARY + ": "}
            open={true}
            size={"md"}
            onClose={() => {
              setManageReturnDialog(false);
            }}
          >
            <ItemReturn
              salesInvoiceRef={salesInvoiceRef}
              selectedRow={selectedRow}
              setSelectedRow={setSelectedRow}
              reloadGrid={reloadGrid}
              setManageReturnDialog={setManageReturnDialog}
            />
          </UiDialog>
        )}

        {managePreviewDialog && (
          <UiDialog
            title={LABELS.SALES_BILL_PREVIEW}
            open={true}
            size={"md"}
            onClose={() => {
              setManagePreviewDialog(false);
            }}
          >
            <div style={{ height: "100%" }}>
              <div
                style={{
                  height: "70%",
                  overflow: "auto",
                  marginBottom: "1.5rem",
                }}
              >
                <SalesInvoiceBillPrint selectedRow={selectedRow} />
                {/* <Preview selectedRow={selectedRow} /> */}
              </div>
              {/* <div
                style={{
                  margin: "0.4rem",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "right",
                  width: "95%",
                  zIndex: 999,
                  position: "fixed",
                  bottom: 0,
                  marginLeft: -2,
                  marginTop: 20,
                  backgroundColor: "lightgrey",
                }}
              >
                <div
                  style={{
                    width: "35%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <Btn
                    text={LABELS.GENERATE_BILL}
                    onClick={"generatesalesBill"}
                    marginRight={"0.1rem"}
                    bgColor={COLORS.GRID_ADD_NEW}
                    //  loading={isSubmit}
                  />
                </div>
              </div> */}
            </div>
          </UiDialog>
        )}
      </div>
    </React.Fragment>
  );
};

export default withSnackbar(SalesInvoice);
